function get(key) {
	if (!window.localStorage) {
		return null;
	}

	return window.localStorage.getItem(key);
}

function getArray(key) {
	const arr = get(key);

	return arr ? decodeURIComponent(arr).split(',') : [];
}

function getFromCookie(key) {
	if (!window.navigator.cookieEnabled) {
		return null;
	}

	const cookieArr = document.cookie.match(key + '=([^;]*)');

	return cookieArr?.[1] ?? null;
}

module.exports = {
	get,
	getArray,
	getFromCookie
};
